import { useState, useEffect } from 'react';
import { Cookie } from '@phosphor-icons/react';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setVisible(false);
  };

  const handleRefuse = () => {
    localStorage.setItem('cookie_consent', 'refused');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 left-0 right-0 z-[9999] bg-desti-surface/95 backdrop-blur-xl border-t border-white/10 px-6 py-5 md:py-4"
    >
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <Cookie size={20} weight="duotone" className="text-desti-gold shrink-0" />
          <p className="text-sm text-white/70">
            Nous utilisons des cookies pour ameliorer votre experience. En continuant, vous acceptez leur utilisation.
          </p>
        </div>
        <div className="flex items-center gap-3 shrink-0">
          <button
            onClick={handleRefuse}
            className="text-sm text-white/50 hover:text-white transition-colors px-4 py-2 border border-white/10 hover:border-white/20"
            data-testid="cookie-refuse-btn"
          >
            Refuser
          </button>
          <button
            onClick={handleAccept}
            className="text-sm bg-desti-gold text-desti-black font-medium px-6 py-2 hover:bg-desti-gold-hover transition-colors"
            data-testid="cookie-accept-btn"
          >
            Accepter
          </button>
        </div>
      </div>
    </div>
  );
}
